import { render, staticRenderFns } from "./GeneralImagesList.vue?vue&type=template&id=645446c2&scoped=true&"
import script from "./GeneralImagesList.vue?vue&type=script&lang=js&"
export * from "./GeneralImagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645446c2",
  null
  
)

export default component.exports